











































import { defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "ParticipantConsentRejectedConfirm",
  components: { BaseButton, BaseConfirm },
  props: {
    value: { type: Boolean, required: true },
  },
  setup() {
    const contactUsUrl: Location = { name: "messages", params: { userId: "1" } };

    return {
      contactUsUrl,
    };
  },
});
